<div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">Memorandum of Understanding</h5>
</div>
<div class="modal-body modal-dialog-scrollable">
    <div class="row" [innerHtml]="ackLanguage"></div>
</div>
<div class="modal-footer">
    <div class="row">
        <div class="form-check">
            <input
                pcgControlRef
                id="isAcknowledged"
                class="form-check-input"
                type="checkbox"
                (click)="saveAcknowledgement()"
            />
            <label for="isAcknowledged" class="form-check-label">
                I acknowledge and accept the Memorandum of Understanding for {{ eventName }}
            </label>
        </div>
    </div>
</div>
